export default __webpack_public_path__ + "static/media/inverted-mobile-heart.c3e926ed.svg";